// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListBlock-module--wrapper--3Dhnq","list":"ListBlock-module--list--3m_56","listItem":"ListBlock-module--list-item--3beJF","body":"ListBlock-module--body--5xpNc"};